import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const IconFrame: FunctionComponent<Props> = ({ children, className = '', testId = TEST_ID }) => (
    <span className={`${styles.iconFrame} ${className}`} data-testid={testId}>
        {children}
    </span>
);

export default IconFrame;
